var _defs, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLogoDark = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187.664,
    height: 33.684,
    viewBox: "0 0 187.664 33.684",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#4a4a49}.cls-2{fill:#00c43c}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-62.963 -73.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M86.409 99.858a.833.833 0 0 1-.871.873h-17.5c.616 3.745 3.8 6.465 8.209 6.465a10.129 10.129 0 0 0 6-1.951c.461-.359.871-.307 1.128.206l1.335 2.206a.9.9 0 0 1-.207 1.231 14.144 14.144 0 0 1-8.822 2.617c-7.338 0-12.725-5.232-12.725-12.261 0-6.926 4.978-12.263 12.109-12.263 6.772 0 11.337 4.978 11.337 12.056zm-18.315-2.77h13.442v-.1a6.244 6.244 0 0 0-6.31-5.848 7 7 0 0 0-7.133 5.948z",
    className: "cls-1",
    "data-name": "Path 33",
    transform: "translate(0 -4.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M101.523 99.294c0-6.976 5.592-12.313 12.825-12.313a13.376 13.376 0 0 1 7.645 2.053.875.875 0 0 1 .257 1.282l-1.335 2.308a.791.791 0 0 1-1.18.256 9.139 9.139 0 0 0-4.823-1.232c-4.873 0-8.156 3.233-8.156 7.645 0 4.309 3.283 7.542 7.952 7.542a9.939 9.939 0 0 0 5.028-1.18c.514-.307.873-.205 1.078.2l1.384 2.463a.8.8 0 0 1-.306 1.181 13.464 13.464 0 0 1-7.542 2c-7.594.001-12.827-5.329-12.827-12.205z",
    className: "cls-1",
    "data-name": "Path 34",
    transform: "translate(-12.123 -4.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M134.479 99.318a12.548 12.548 0 1 1 12.568 12.211 12.264 12.264 0 0 1-12.568-12.211zm19.906 0a7.365 7.365 0 1 0-7.338 7.542 7.44 7.44 0 0 0 7.338-7.542z",
    className: "cls-1",
    "data-name": "Path 35",
    transform: "translate(-22.484 -4.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M233.905 88.316v21.854a.786.786 0 0 1-.873.873h-2.822a.78.78 0 0 1-.821-.821l-.154-2.925a10.322 10.322 0 0 1-8.618 4.207c-6.465 0-11.39-5.232-11.39-12.261s4.978-12.263 11.442-12.263a10.868 10.868 0 0 1 8.413 3.593l.153-2.31a.824.824 0 0 1 .873-.821h2.924a.787.787 0 0 1 .873.874zm-4.875 10.928c-.05-4.361-2.974-7.594-7.387-7.594a7.6 7.6 0 0 0 0 15.187c4.413-.001 7.387-3.237 7.387-7.593z",
    className: "cls-1",
    "data-name": "Path 36",
    transform: "translate(-45.984 -4.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M275.772 74.494v31.475a.809.809 0 0 1-.873.873h-2.566a.8.8 0 0 1-.873-.821l-.152-2.872a10.569 10.569 0 0 1-8.723 4.154c-6.465 0-11.492-5.232-11.492-12.261s4.873-12.263 11.338-12.263a10.335 10.335 0 0 1 8.261 3.8V74.494a.81.81 0 0 1 .873-.873h3.335a.81.81 0 0 1 .872.873zm-4.872 20.55c0-4.361-2.974-7.594-7.387-7.594a7.6 7.6 0 0 0 0 15.187c4.41-.001 7.387-3.182 7.387-7.593z",
    className: "cls-1",
    "data-name": "Path 37",
    transform: "translate(-59.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M295.128 110.381l.052-21.854a.772.772 0 0 1 .821-.873h3.438a.773.773 0 0 1 .821.873v21.854a.772.772 0 0 1-.821.873H296a.786.786 0 0 1-.872-.873z",
    className: "cls-1",
    "data-name": "Path 38",
    transform: "translate(-72.991 -4.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M295.128 78.045l.052-3.55a.772.772 0 0 1 .821-.873h3.438a.773.773 0 0 1 .821.873v3.55a.771.771 0 0 1-.821.873H296a.786.786 0 0 1-.872-.873z",
    className: "cls-1",
    "data-name": "Path 39",
    transform: "translate(-72.991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M308.934 109.066c-.514-.256-.564-.666-.307-1.18l1.385-2.411a.766.766 0 0 1 1.18-.256 13.123 13.123 0 0 0 7.234 2.1c2.617 0 4.206-.975 4.206-2.769 0-1.642-1.23-2.463-4.975-3.388-4.618-1.128-8.415-2.924-8.415-7.13 0-4.257 3.695-6.977 9.237-6.977a16.422 16.422 0 0 1 8.361 2.1.754.754 0 0 1 .257 1.18l-1.284 2.365a.752.752 0 0 1-1.18.255 12.875 12.875 0 0 0-6.413-1.692c-2.206 0-3.8.769-3.8 2.513 0 1.539 1.437 2.156 5.44 3.131 4.975 1.282 7.952 2.974 7.952 7.387 0 4.309-3.7 7.233-9.7 7.233a17.43 17.43 0 0 1-9.178-2.461z",
    className: "cls-1",
    "data-name": "Path 40",
    transform: "translate(-77.187 -4.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M177.57 88.27a.937.937 0 0 0-.974-.616h-3.8c-.616 0-.871.411-.616 1.026l1.993 4.332a5.681 5.681 0 0 0 5.169 3.325h1.668z",
    className: "cls-2",
    "data-name": "Path 41",
    transform: "translate(-34.307 -4.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M198.307 87.769h-3.593a1.121 1.121 0 0 0-1.026.668l-6.8 16.389-.888-2.083a5.521 5.521 0 0 0-5.074-3.346h-1.71l5.162 11.431a.9.9 0 0 0 .975.616h2.668a.9.9 0 0 0 .976-.616l9.925-22.034c.256-.564-.001-1.025-.615-1.025z",
    className: "cls-1",
    "data-name": "Path 42",
    transform: "translate(-36.549 -4.448)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoDark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-dark.49781e87.svg";
export { ForwardRef as ReactComponent };